import type {
  EventSubtask,
  EventId,
  PlanEvent,
  RecurrenceRule,
} from "../../../shared/types";
import { createPlanEvent } from "../../../shared/types";
import { localEventSchema } from "../../../shared/schemas/local.schema";

const STORAGE_KEY = "palnia_events";

export function loadEvents(): PlanEvent[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.map(migrateEvent);
  } catch {
    return [];
  }
}

export function migrateEvent(raw: unknown): PlanEvent {
  const parsed = localEventSchema.safeParse(raw);
  if (!parsed.success) {
    return createPlanEvent(
      "Événement récupéré",
      "personal",
      "",
      "09:00",
      "10:00",
    );
  }
  const e = parsed.data;
  return {
    id: e.id as EventId,
    title: e.title,
    category: e.category,
    date: e.date,
    startTime: e.startTime,
    endTime: e.endTime,
    createdAt: e.createdAt,
    description: e.description,
    notes: e.notes,
    tags: e.tags,
    recurrence: e.recurrence as RecurrenceRule | null,
    excludedDates: e.excludedDates,
    detachedFromId: (e.detachedFromId ?? undefined) as EventId | undefined,
    reminderMinutes: e.reminderMinutes,
    reminderTime: e.reminderTime ?? null,
    reminderType: e.reminderType ?? null,
    allDay: e.allDay,
    eventSubtasks: e.eventSubtasks.map((s) => ({
      ...s,
      id: s.id as import("../../../shared/types").SubtaskId,
    })) as EventSubtask[],
  };
}

export { STORAGE_KEY };
